import { render, staticRenderFns } from "./SchedulingIpam.vue?vue&type=template&id=2c7a7ba3&"
import script from "./SchedulingIpam.vue?vue&type=script&lang=js&"
export * from "./SchedulingIpam.vue?vue&type=script&lang=js&"
import style0 from "./SchedulingIpam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports